import { SelectMultipleValueInterface, SelectMultipleInterface } from '../interfaces/select-multiple.interface';

export class SelectMultipleValueModel {
  id: number;
  name: string;
  code: string;

  constructor(
    obj: SelectMultipleValueInterface ) {

    // this.id = obj && obj.idx >= -1 ? obj.idx : null;
    this.id = obj && +(obj.id);
    this.name = obj && obj.name;
    this.code = obj && obj.name;
  }
}

export class SelectMultipleModel {
  label: string;
  value: SelectMultipleValueInterface | any;

  constructor( obj: SelectMultipleInterface | any ) {

    this.label = obj && obj.name;
    this.value = new SelectMultipleValueModel( obj );
  }
}
